var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"culture bold"},[_c('div',[_vm._v("你以为这个页面会有东西？")]),_c('div',[_vm._v("你错了")]),_c('div',[_vm._v("设计没给我设计稿，怎么会有东西？")])])}]

export { render, staticRenderFns }